'use strict';

var TO_STRING_TAG_SUPPORT = require('../internals/to-string-tag-support');

var classof = require('../internals/classof'); // `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring


module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};